import { useState, FormEvent } from 'react';
import { t, useTranslation } from '../i18n';

interface Props {
  onCancel: () => void;
  onSave: (pin: string) => void;
}

export default function RememberDeviceModal({ onCancel, onSave }: Props) {
  useTranslation();
  const [pin, setPin] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);

  function submit(e: FormEvent) {
    e.preventDefault();
    if (pin.length < 4) {
      setError(t('modal.remember.errShort'));
      return;
    }
    if (pin !== confirm) {
      setError(t('modal.remember.errMismatch'));
      return;
    }
    onSave(pin);
  }

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{t('modal.remember.title')}</h2>
        <p className="hint">{t('modal.remember.hint')}</p>
        <form onSubmit={submit}>
          <label>
            <span>{t('modal.remember.pin')}</span>
            <input
              type="password"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              minLength={4}
              required
              autoFocus
            />
          </label>
          <label>
            <span>{t('modal.remember.confirm')}</span>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              minLength={4}
              required
            />
          </label>
          <div className="modal-actions">
            <button type="button" className="ghost" onClick={onCancel}>{t('common.cancel')}</button>
            <button type="submit" className="primary">{t('common.save')}</button>
          </div>
          {error && <div className="error">{error}</div>}
          <p className="warn">{t('modal.remember.warn')}</p>
        </form>
      </div>
    </div>
  );
}
